<template>
  <div class="portada-xv" ref="rootRef" aria-label="Portada de XV">
    <!-- FLORES Y RAMAS DECORATIVAS -->
    <div v-for="i in 6" :key="'group-'+i" :class="'flor-group flor-' + i">
      <img src="@/assets/fl.png" class="flor-img" alt="" />
      <!-- RAMA QUE NACE DE LA FLOR -->
      <img src="@/assets/rama.png" class="rama-img" alt="" />
    </div>

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/disco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/6_5_11zon.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <!-- TEXTO PRINhgjhgjgjhgjnhghjhCIPAL -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        Con la bendición de Dios <br />
        y de mis padres
      </p>

      <h1 class="nombre-protagonista"> Carlos Casanola   &nbsp; </h1>

<img
  src="@/assets/ampersand.png"
  class="ampersand ampersand-padres"
  alt="&"
/>
<h1 class="nombre-protagonista">
  Irma Pilar <span class="g-great">G</span>ómez&nbsp;
</h1>

      <div class="separador-elegante" aria-hidden="true"></div>

      <p class="parrafo-presentacion">
        Hay momentos que definen nuestra vida, quedando grabados en el alma y la memoria.
        Hoy experimento uno de esos instantes especiales y quiero compartirlo con quienes
        tienen un lugar en mi corazón.
      </p>
    </section>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = $('.flor-img')
      const ramas = $('.rama-img')
      const grupos = $('.flor-group')
      
      const texto = [
        '.frase-bendicion',
        '.nombre-protagonista:not(.padrino-nombre)',
        '.separador-elegante',
        '.padrinos-label',
        '.padrino-nombre',
        '.parrafo-presentacion',
                '.ampersand',

      ].flatMap($)

      // Estado inicial suave: un poco de escala y desenfoque
      gsap.set([...foto, ...texto], { autoAlpha: 0, y: 20 })
      gsap.set(flores, { autoAlpha: 0, scale: 0.85, filter: 'brightness(1.3)' })
      gsap.set(ramas, { autoAlpha: 0, scale: 0, transformOrigin: "center center" })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Aparece la foto
          tl.fromTo(
            foto,
            { scale: 0.96, filter: 'blur(8px)' },
            { autoAlpha: 1, scale: 1, filter: 'blur(0px)', duration: 1.4 }
          )

          // 2. Las flores "florecen" (crecen suavemente)
          tl.to(
            flores,
            {
              autoAlpha: 1,
              scale: 1,
              filter: 'brightness(1)',
              duration: 1.2,
              stagger: 0.15,
              ease: "back.out(1.2)"
            },
            '-=1'
          )

          // 3. Las ramas nacen de forma orgánica
          tl.to(
            ramas,
            {
              autoAlpha: 1,
              scale: 1,
              duration: 1.5,
              stagger: 0.2,
              ease: "power1.inOut"
            },
            '-=0.8'
          )

          // 4. Aparece el texto
          tl.to(texto, { autoAlpha: 1, y: 0, duration: 1, stagger: 0.2 }, '-=0.6')

          // --- ANIMACIONES INFINITAS (EFECTO MÁGICO) ---

          // Pulso de "respiración" para las flores (Escala y Brillo sutil)
          gsap.to(flores, {
            scale: 1.04,
            filter: 'brightness(1)',
            duration: 2.5,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut",
            stagger: { each: 0.4, from: "random" }
          })

          // Balanceo muy lento de los grupos (flotación)
          grupos.forEach((grupo, i) => {
            gsap.to(grupo, {
              y: "+=12",
              x: "+=5",
              duration: 4 + i,
              repeat: -1,
              yoyo: true,
              ease: "sine.inOut"
            })
          })

          // Respiración de la foto principal
          gsap.to(foto, {
            scale: 1.015,
            duration: 5,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* Estilos base de los contenedores de flores */
.flor-group {
  position: absolute;
  z-index: 3; /* 🔥 sube todo el grupo */
  will-change: transform, opacity;
}

.flor-img {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 4; /* 🔥 la flor encima */
}

/* Estilo de la rama naciendo */
.rama-img {
  position: absolute;
  top: 5%;
  left: -10%; /* 🔥 ajustado para que no se salga */
  width: 280%; /* 🔥 tamaño controlado */
  height: 200px;
  z-index: 3; /* 🔥 visible debajo de la flor */
  opacity: 1; /* 🔥 para que se note */
  pointer-events: none;
}
.ampersand{
  width:32px;

  height:auto;

  display:block;
padding-bottom: 20px;
  margin:0 auto;

  position:relative;

  z-index:5;

  opacity:0;

  filter:
    drop-shadow(0 2px 8px rgba(212,175,55,.35))
    drop-shadow(0 0 14px rgba(255,215,120,.18));
}

.g-great {
  font-family: "Great Vibes", cursive;
}
/* Posiciones exactas originales */
.flor-1 { top:35px; left:-5px; width: min(34vw, 140px) !important; z-index:0; }
.flor-2 { top:80px; right:-50px; width: min(40vw, 140px);  }
.flor-3 { bottom:-70px; left:-30px; width: min(44vw, 140px) !important; transform: rotate(-0deg); z-index: 10;}
.flor-4 { top: 97px; left: 5px; width: min(40vw, 140px); transform: translateX(-50%) rotate(0deg); z-index: 0; }
.flor-5 { bottom: 20px; right: 0px; width: min(46vw, 140px); transform: translateX(-50%) ; z-index: 8; opacity: 0 !important; }
.flor-6 { top: 450px; right: -140px; width: min(40vw, 140px); transform: translateX(-50%); z-index: 2; }

/* --- RESTO DE TU CSS ORIGINAL SIN CAMBIOS --- */
.padrinos-label{ font-family: "Playfair Display", serif; font-size: clamp(18px, 2.6vw, 24px); color:#2f2e2e; margin-top: 12px; }
.padrino-nombre{ font-family: "titulos", cursive; font-size: 40px; color:#e6b1c4; margin: 4px 0; }
.portada-xv{ position:relative; width:100%; min-height:100vh; overflow:visible; display:flex; flex-direction:column; align-items:center; justify-content:flex-start; padding:48px 16px 56px; }
.imagen-xv-wrapper{ width: min(92vw, 360px); height: calc(min(92vw, 360px) * 1.5); margin-top: 6px; border-radius: 180px 180px 0 0; overflow: hidden; z-index: 2; background:#fff; box-shadow: 0 12px 40px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.06); will-change: transform, filter, opacity; }
.imagen-xv{ width:100%; height:100%; object-fit:cover; display:block; }
.texto-xv{ max-width: 620px; text-align:center; margin-top: 22px; padding: 0 8px; }
.frase-bendicion{ font-family: "Playfair Display", serif; font-size: clamp(18px, 2.6vw, 24px); color:#2f2e2e; line-height:1.5; margin: 20px 0 10px; }
.separador-elegante{ width:110px; height:2px; margin:12px auto 16px; background: linear-gradient(90deg, transparent, #d9b7c6, transparent); border-radius: 2px; }
.nombre-protagonista {
  font-family: "Great Vibes", cursive;
  margin: 0 0 9px 0;
  line-height: 1.3;
  letter-spacing: 2px;
font-size: 41px;
padding-left: 10px;
  background: linear-gradient(
    110deg,
    #a67c00 30%,
    #bf953f 45%,
    #ffffff 50%,
    #bf953f 55%,
    #a67c00 70%
  );

  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;

  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5));
  -webkit-font-smoothing: antialiased;
}

.parrafo-presentacion{ font-family: "quote", sans-serif; font-size: clamp(16px, 2.6vw, 16px); color:#3d3c3c; line-height:1.7; margin-top: 6px; }
.bola{ position:absolute; width:220px; animation: girar 10s linear infinite; opacity:.85; z-index:1; opacity:0 !important; will-change: transform; }
.bola-izquierda{ left:-20px; bottom:-50px; z-index:9;}
@keyframes girar{ from{transform:rotate(0)} to{transform:rotate(360deg)} }
@media (min-width: 992px){ .portada-xv{ padding-top:64px; } .imagen-xv-wrapper{ margin-top: 0; } }
</style>